if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (this.isSubmitting || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.isSubmitting = true;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.cache = 'no-store';

        const formData = new FormData(this.form);
        let optimisticAddKey = '';
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
          if (typeof this.cart.renderOptimisticAddCard === 'function') {
            optimisticAddKey = this.cart.renderOptimisticAddCard(this.getOptimisticCartMeta(formData));
          }
        }
        config.body = formData;

        const addRequest = () => fetch(this.getCartAddEndpoint(), config);
        const addResponse =
          this.cart && typeof this.cart.enqueueCartOperation === 'function'
            ? this.cart.enqueueCartOperation(addRequest)
            : addRequest();

        addResponse
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (optimisticAddKey && this.cart && typeof this.cart.clearOptimisticAddCards === 'function') {
                this.cart.clearOptimisticAddCards(optimisticAddKey);
              }
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            if (optimisticAddKey && this.cart && typeof this.cart.clearOptimisticAddCards === 'function') {
              this.cart.clearOptimisticAddCards(optimisticAddKey);
            }
            console.error(e);
          })
          .finally(() => {
            this.isSubmitting = false;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.removeAttribute('disabled');
            }
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getCartAddEndpoint() {
        const route = String((window.routes && window.routes.cart_add_url) || '/cart/add.js').trim();
        if (route.includes('.js')) return route;
        const [path, query = ''] = route.split('?');
        return `${path.replace(/\/$/, '')}.js${query ? `?${query}` : ''}`;
      }

      getOptimisticCartMeta(formData) {
        const scope = this.closest('product-info') || this.closest('section') || document;
        const titleNode =
          scope.querySelector('.product__title h1') ||
          scope.querySelector('.product__title') ||
          scope.querySelector('[data-product-title]') ||
          scope.querySelector('h1') ||
          scope.querySelector('.card__heading');
        const imageNode =
          scope.querySelector('.product__media-item.is-active img') ||
          scope.querySelector('.product__media img') ||
          scope.querySelector('img');
        const selectedOptions = Array.from(
          this.form.querySelectorAll('select[name^="options"] option:checked, input[name^="options"]:checked')
        )
          .map((option) => option.textContent || option.value)
          .map((value) => String(value || '').trim())
          .filter((value) => value && value !== 'Default Title');

        return {
          title: titleNode ? titleNode.textContent.trim() : window.variantStrings?.addToCart || 'Product',
          variantTitle: selectedOptions.join(' / '),
          image: imageNode ? imageNode.currentSrc || imageNode.src : '',
          quantity: formData.get('quantity') || 1,
          variantId: formData.get('id'),
        };
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
